import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { SEAMLESSVIEW_SOURCES } from '../seamless-rf-view-map/seamless-rf-view-map-cnst';
import { Subject } from 'rxjs';
import { DataService } from 'src/app/main/shared/services/data.service';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';

@Component({
  selector: 'app-seamless-rf-view-sidebar',
  templateUrl: './seamless-rf-view-sidebar.component.html',
  styleUrls: ['./seamless-rf-view-sidebar.component.scss']
})
export class SeamlessRfViewSidebarComponent implements OnInit {
  queryParams: any;
  isInitialLoad: boolean = false;
  sourceOptions: any
  selected: string;
  selectedSource: any;
  selectedStartDate: object = { required: true };
  selectedEndDate: object = { required: true };
  validation: boolean[] = new Array(5).fill(true);
  sDate: any;
  eDate: any;
  format: object = { value: 'yyyyMMdd' };
  minDate: any;
  maxDate: any;
  showDateAlert: boolean = false;
  destroy: any = new Subject();
  subscriptions: any = [];
  sessionStorage: any = {
    params: {}
  };

  constructor(private gisUtils: UtilsService, private route: ActivatedRoute, private router: Router, private dataService: DataService, private gisMapComp: GisDimsMapComponent) {
    const url = this.router.url;
    const urlparams = url.split('/');
    this.selected = urlparams[2];
  }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents()
    this.setParams()
  }

  subscribeEvents() {
    const selectedParamsRef = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      const paramKeys = Object.keys(params);
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (paramKeys.length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.gisUtils.setSelectedParams(this.queryParams);
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.selectedSource = this.queryParams['source']
        let sourceList = SEAMLESSVIEW_SOURCES
        this.sourceOptions = Object.keys(sourceList).map(key => {
          return { key: key, value: sourceList[key] }
        })
        this.setMinMaxDate()
      }
    });
    this.subscriptions.push(selectedParamsRef)
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  onSubmit() {
    const start = new Date(this.selectedStartDate['value']);
    const end = new Date(this.selectedEndDate['value']);

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset today's time to midnight

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    if (start.toDateString() === new Date().toDateString()) {
      // Case 1: Today
      start.setHours(0, 0, 0, 0);
      end.setTime(Date.now());
    } else {
      // Case 2 & 3: Yesterday or any other day (past/future)
      start.setHours(0, 10, 0, 0);
      end.setHours(23, 50, 0, 0);
    }

    this.selectedStartDate['value'] = start;
    this.selectedEndDate['value'] = end;

    const startMs = start.getTime();
    const endMs = end.getTime();
    console.log(startMs, endMs, "Milliseconds range");

    // Update query params
    let options = { ...this.queryParams };
    options['startDate'] = startMs;
    options['endDate'] = endMs;
    options['source'] = this.selectedSource;

    this.gisUtils.setSelectedParams(options);
  }

  setMinMaxDate() {
    const now = new Date(Number(this.queryParams['endDate']));
    const start = new Date(Number(this.queryParams['startDate']));
    this.maxDate = new Date()
    this.selectedStartDate = { value: start, required: true };
    this.selectedEndDate = { value: now, required: true };
    const currentDate = new Date();
    const lastMonthDate = new Date();
    lastMonthDate.setMonth(currentDate.getMonth() - 1); // Set to one month before the current date
    this.minDate = lastMonthDate;
  }

  requestSelectedFilterParams() {
    console.log('[SEAMLESS SIDEBAR] requestSelectedFilterParams — isInitialLoad:', this.isInitialLoad);
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'SEAMLESSVIEW';
    if (this.isInitialLoad) {
      let metaInfo: any = localStorage.getItem('metaInfo');
      let metaInfoJson: any = !isNullOrUndefined(metaInfo) ? JSON.parse(metaInfo) : {};
      let finalMetaInfo = metaInfoJson;
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(finalMetaInfo.userDetailsJson.data.location, finalMetaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1];
      currentUrlParams['locName'] = currentLocations[0];
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['source'] = 'IMD_RADAR_MODEL_INPUT_NOWCAST';
      const now = new Date();
      const start = new Date(now);
      start.setHours(0, 0, 0, 0);
      currentUrlParams['startDate'] = start.getTime();
      currentUrlParams['endDate'] = now.getTime();
      this.isInitialLoad = false;
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  onSeamlessSourceChange() {
    let options = { ...this.queryParams }
    options['source'] = this.selectedSource;
    this.gisUtils.setSelectedParams(options);
  }

  onstartDateChange() {
    this.selectedEndDate['value'] = ''
  }

  onendDateChange() {
    if (this.isWithinOneDay(this.selectedStartDate['value'], this.selectedEndDate['value'])) {
      this.showDateAlert = false
    } else {
      this.selectedEndDate['value'] = ''
      this.showDateAlert = true
    }
  }

  isWithinOneDay(start: Date, end: Date): boolean {
    const differenceInMs = Math.abs(end.getTime() - start.getTime());
    const oneDayInMs = 24 * 60 * 60 * 1000; // 86400000 ms
    return differenceInMs <= oneDayInMs;
  }

}
